{
	"title": "Reports",
	"subtitle": "Print a sport's schedule, a meet's start list or results, its medallists and the medal standing on A4 — {{games}}.",
	"scope": "Printed from your browser: use “Save as PDF” in the print window to keep a copy. Saved versions and signatures are not kept here yet.",
	"sport": "Sport",
	"pickSport": "Pick a sport",
	"pickSportBody": "Choose a sport to see its reports.",
	"loading": "Loading…",
	"retry": "Retry",
	"errors": {
		"gamesTitle": "Couldn't load the games"
	},
	"empty": {
		"noGamesTitle": "No games yet",
		"noGamesBody": "Reports appear once a games is set up in GMS.",
		"noSportsTitle": "No sports in this games yet",
		"noSportsBody": "Sports and events are set up in GMS."
	},
	"preview": "Preview & print",
	"hide": "Hide preview",
	"print": "Print",
	"paper": "A4 preview",
	"truncated": "Only the first {{n}} meets are included.",
	"catalogue": {
		"schedule": {
			"title": "Competition schedule",
			"hint": "Every meet of the sport, day by day. Pick a day for the daily schedule.",
			"day": "Day",
			"allDays": "All days",
			"noMeets": "This sport has no meets yet.",
			"discipline": "Discipline",
			"allDisciplines": "All disciplines"
		},
		"meet": {
			"title": "Start list / Results",
			"hint": "One meet's A4 sheet: the start list until it has results, the results after.",
			"meet": "Meet",
			"pick": "Pick a meet",
			"noMeets": "This sport has no meets yet."
		},
		"medallists": {
			"title": "Medallists by event",
			"hint": "The medals the medal desk awarded in this sport, event by event.",
			"none": "No medals awarded in this sport yet."
		},
		"standing": {
			"title": "Medal standing",
			"hint": "Gold, silver and bronze by NOC.",
			"scope": "Standing for",
			"thisSport": "This sport",
			"wholeGames": "The whole games",
			"none": "No medals awarded yet."
		}
	},
	"sheet": {
		"medallistsTitle": "Medallists by event",
		"medallistsCount_one": "{{n}} medal",
		"medallistsCount_other": "{{n}} medals",
		"standingTitle": "Medal standing",
		"standingWhole": "All sports",
		"printedAt": "Printed {{at}}",
		"medal": {
			"GOLD": "Gold",
			"SILVER": "Silver",
			"BRONZE": "Bronze"
		},
		"col": {
			"medal": "Medal",
			"name": "Name",
			"noc": "NOC",
			"rank": "Rank",
			"gold": "Gold",
			"silver": "Silver",
			"bronze": "Bronze",
			"total": "Total"
		},
		"total": "Total"
	}
}
